import { render, staticRenderFns } from "./index.vue?vue&type=template&id=379adec3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=379adec3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379adec3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompilationHeaderImg: require('/home/bitrix/frontend/components/compilations/CompilationHeaderImg.vue').default,MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default,ShareBlock: require('/home/bitrix/frontend/components/compilations/ShareBlock.vue').default,CompilationDescription: require('/home/bitrix/frontend/components/compilations/CompilationDescription.vue').default,Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default,ItemList: require('/home/bitrix/frontend/components/gallery/ItemList.vue').default,Pagination: require('/home/bitrix/frontend/components/other/Pagination.vue').default,LinkedCompSection: require('/home/bitrix/frontend/components/compilations/LinkedCompSection.vue').default,Sponsors: require('/home/bitrix/frontend/components/compilations/Sponsors.vue').default})
